/**
 * Created by Louis on 15/06/2016.
 */
window.selectCallback = function(variant, selector){
    var form = $(document.getElementById(selector.domIdPrefix)).closest('form');
    var button = form.find('input[type="submit"]');
    var price = form.closest('.product-information').find('.price'); // >

    var soleIndex = -1;
    var sizeIndex = -1;
    for(var i = 0; i < selector.selectors.length; i++) {
      if(selector.selectors[i].name.toLowerCase() === "sole") soleIndex = i;
      if(selector.selectors[i].name.toLowerCase() === "size") sizeIndex = i;
    }

    if(soleIndex > -1 && sizeIndex > -1) {
      var soleSelect = form.find('#productSelect-option-'+soleIndex);
      var sizeSelect = form.find('#productSelect-option-'+sizeIndex);
      var soleSwatchInputs = form.find('#fieldset-Sole input');
      var sizeSwatchInputs = form.find('#fieldset-Size input');
      var sole = soleSelect.get(0).value;
      var size = sizeSelect.get(0).value;
      sizes = [];
      soles = [];
      for(var i = 0; i < selector.product.variants.length; i++) {
        var prod = selector.product.variants[i];
        if(prod['option'+(soleIndex+1)] === sole && prod.available) sizes.push(Number(prod['option'+(sizeIndex+1)]));
        if(prod['option'+(sizeIndex+1)] === size && prod.available) soles.push(prod['option'+(soleIndex+1)]);
      }
      sizes = new Set(sizes);
      soles = new Set(soles);
      for(var i = 0; i < sizeSwatchInputs.length; i++) {
        var sizeInput = sizeSwatchInputs.eq(i);
        if(sizes.has(Number(sizeInput.get(0).value))) {
          sizeInput.removeClass('disabled');
          sizeInput.prop('disabled', false);
          var label = $("label[for='"+sizeInput.attr('id')+"']");
          label.removeClass('disabled').addClass('available');
        }
        else{
          sizeInput.addClass('disabled');
          sizeInput.prop('disabled', true);
          var label = $("label[for='"+sizeInput.attr('id')+"']");
          label.addClass('disabled').removeClass('available');
        }
        
      }
      for(var i = 0; i < soleSwatchInputs.length; i++) {
        var soleInput = soleSwatchInputs.eq(i);
        if(true){ //soles.has(soleInput.get(0).value)) {
          soleInput.removeClass('disabled');
          soleInput.prop('disabled', false);
          var label = $("label[for='"+soleInput.attr('id')+"']");
          label.removeClass('disabled').addClass('available');
        }
        // else{
        //   soleInput.addClass('disabled');
        //   soleInput.prop('disabled', true);
        //   var label = $("label[for='"+soleInput.attr('id')+"']");
        //   label.addClass('disabled').removeClass('available');
        // }
      }
    }

    if (variant) {
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
        if (radioButton.size()) {
          radioButton.get(0).checked = true;
        }
      }
    }

    //Update price & add-to-cart button states
    if(variant && variant.available == true) {
        button.removeAttr('disabled');
        button.val("ADD TO CART");
        var priceHTML = Shopify.formatMoney(variant.price, "<span class='money'>{{amount_no_decimals}} kr</span>");
            price.html(priceHTML);
    }
    else {
        button.attr('disabled', 'disabled');
        if(variant) {
            button.val("Sold Out");
            price.html(Shopify.formatMoney(variant.price, "<span class='money'>{{amount_no_decimals}} kr</span>") + ' <span class="soldout">'+"Sold Out"+'</span>');
        } else {
            price.html("Unavailable");
        }
    }
    if (variant && variant.featured_image) {
        var originalImage = $(".product-images-main img");
        var newImage = variant.featured_image;
        var element = originalImage[0];
        Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
            $(element).attr('src', newImageSizedSrc);
        });
    }

    Currency.convertAll(shopCurrency, $('[name=currencies]').val());
    $('.selected-currency').text(Currency.currentCurrency);
};

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length,c.length);
        }
    }
    return "";
}

function removeCookie(cname) {
    setCookie(cname,"",-1);
}

(function($) {

    $(document).on('optionate', 'select[name="id"]', function(){
        if(typeof $(this).data('optionated') == 'undefined') {
            $(this).data('optionated', true);
            var prodId = parseInt($(this).attr('id').split('-')[2]);
            for(var i=0; i<window.productJSON.length; i++) {
                var prodJSON = window.productJSON[i];
                if(prodJSON.id == prodId) {
                    new Shopify.OptionSelectors($(this).attr('id'), {
                        product: prodJSON,
                        onVariantSelected: window.selectCallback,
                        enableHistoryState: false
                    });

                    break;
                }
            }
        }
    });

    $(".close-alert").click(function() {
        parent = $(this).parents(".alert").addClass("hidden");
    });
 
        $('.swatch :radio').change(function() {
     var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
     var optionValue = jQuery(this).val();
     jQuery(this)
       .closest('form')
       .find('.single-option-selector')
       .eq(optionIndex)
       .val(optionValue)
       .trigger('change');
    });


    $(document).ready(function() {

        if(getCookie("cookiePolicy") === "") {
            $(".cookie-policy-container").delay(1500).animate({bottom: 0}, 500);
        }

        if(getCookie("cartUpdate") !== "") {
            removeCookie("cartUpdate");
            $(".cart-update-alert").removeClass("hidden");
        }

        $(".cookie-accept").click(function(){
            setCookie("cookiePolicy", "true", 3650);
            $(".cookie-policy-container").animate({bottom: - $(".cookie-policy-container").outerHeight() }, 500, function(){$(this).remove()});
        });

        $(".slideshow").each(function(){
            $(this).slick({
                autoplay: true,
                autoplaySpeed: 110000,
                infinite: true,
                useTransform: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                        }
                    }
                ],
                prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
                nextArrow: '<button type="button" class="slick-next slick-arrow"></button>'
            });
        });

        $(".slideshow-3").each(function(){
            $(this).slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 3,
                infinite: true,
                useTransform: true,
                arrows: false,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToShow: 1
                        }
                    }
                ]
            });
        });

        $(".slideshow-4").each(function(){
            $(this).slick({
                autoplay: true,
                autoplaySpeed: 8000,
                slidesToShow: 4,
                infinite: true,
                useTransform: true,
                arrows: false,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            autoplay: true,
                            autoplaySpeed: 5000,
                            arrows: false,
                            dots: false,
                            slidesToShow: 3
                        }
                    }
                ]
            });
        });

        $(".slideshow-4-products").each(function(){
            $(this).slick({
                autoplay: true,
                autoplaySpeed: 8000,
                slidesToShow: 4,
                infinite: true,
                useTransform: true,
                arrows: false,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            autoplay: true,
                            autoplaySpeed: 5000,
                            arrows: false,
                            dots: false,
                            slidesToShow: 3
                        }
                    }
                ]
            });
        });

        $(".slideshow-5").each(function() {
            $(this).slick({
                autoplay: true,
                autoplaySpeed: 11000,
                slidesToShow: 5,
                infinite: true,
                useTransform: true,
                arrows: false,
                dots: false,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            autoplay: true,
                            autoplaySpeed: 11000,
                            arrows: false,
                            dots: true,
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            autoplay: true,
                            autoplaySpeed: 11000,
                            arrows: false,
                            dots: true,
                            slidesToShow: 4
                        }
                    }
                ]
            });
        });

        if($("#RecoverPasswordForm").find(".errors").length > 0){
            var f = $("#RecoverPasswordForm");
            var p = $("#RecoverPasswordForm").children("p");
            p.hide();
            setTimeout(function() {
                f.find(".errors").fadeOut(250, function() {
                    p.fadeIn(250);
                });
            }, 4000);
        }

    }); // End of doc ready function.

    if($(".dd-options").find("li").length > 2) {
        var a = $(".dd-options").find("li");
        for(var i = 0; i < a.length - 2; i ++) {
             a[i].remove();
        }
    }
    /* Find the selected language and display the correct short-description. */
    var english = $(".current-language").text().toLowerCase() === "ly18505";
    $(".short-description").each(function() {
        var that = $(this);
        if(that.hasClass("eng") && english) {
            that.removeClass("hidden");
        }
        else if(that.hasClass("eng") && !english) {
            that.addClass("hidden");
        }
        else if(that.hasClass("sve") && english) {
            that.addClass("hidden");
        }
        else if(that.hasClass("sve") && !english) {
            that.removeClass("hidden");
        }
    });

    /*
     * Calculate days left on preorder items.
     */
    $(".pre-date").each(function(){
        var t = $(this);
        var d = t.text().split("/");
        if(d.length === 3) {
            var tmp = d[0];
            d[0] = d[1];
            d[1] = tmp;
            var date = new Date(d.join("/"));
            var now = Date.now();
            var diff = Math.ceil((date - now)/(1000*60*60*24));
            var days = diff > 1 ? ' days' : ' day'
            t.html("<span class='time'>"+diff+"</span>" + days);
        }

    });

    /*
     * Shopify AJAX API add item to cart.
     */
    var cartHTMLtemplate = [
        '<div id="cart-summary-popup" class="cart-box">',
            '<div class="left">',
                '<div class="title">Added: </div>',
                    '<div class="group">',
                        '<div class="product-images"><div class="product-images-thumbnails"><img src="[[image_url]]" /></div></div>',
                        '<div class="product-info">',
                            '<div>[[title]]</div>',
                            '<div><span class="money">[[price]]</span></div>',
                        '</div>',
                        '<div class="product-details">',
                            '<div>'+"Quantity"+' [[quantity]]</div>',
                            '<div>'+"Total"+' <span class="money"> [[line_price]]</span></div>',
                        '</div>',
                    '</div>',
                '</div>',
            '<div class="right">',
                '<div>',
                    "Subtotal"+' <span class="money">[[subtotal]]</span>',
                '</div>',
                '<div class="cart-text">Excl. Shipping</div>',
                '<div class="group">',
                    '<a id="shop" class="btn inverse" href="#">'+"Keep Shopping"+'</a>',
                    '<a class="btn" href="/cart">'+"Cart"+'</a>',
                '</div>',
            '</div>',
            '<div class="clearfix"></div>',
        '</div>'
    ].join('');
    var addURL = '/cart/add.js', cartURL = '/cart.js', searchURL = '/search';

    add_text = $('form[action="/cart/add"]:not(.noAJAX)').first().find('input[type="submit"]').first().data()

    $('form[action="/cart/add"]:not(.noAJAX)').submit(function(e) {
        var form = $(this);
        var d = false;
        form.find("option:disabled").each(function() {
            if($(this).is(":selected")) d = true;
        });
        form.find(".error-message").hide(0);
        if(d) {
            form.find(".error-message").show(250);
            setTimeout(function() {
                form.find(".error-message").hide(250);
            }, 3500);
            e.preventDefault();
            return;
        }


        form.find('input[type="submit"]').attr('disabled', 'disabled').each(function(){
            $(this).data('prev-content', $(this).val());
        }).val("Adding...");

        $('#cart-summary-popup').find('#shop').triggerHandler('click');

        function cb(itemData) {
            form.find('input[type="submit"]').removeAttr('disabled').each(function(){
                btn = $(this);
                btn.val(btn.data('prev-content'));
            });

            var addedProd = $.parseJSON(itemData);

            $.get(cartURL, function(cart){
                var cartJson = $.parseJSON(cart);
                var addedQty = form.find('input[name="quantity"]').length ? parseInt(form.find('input[name="quantity"]').val()) : 1;
                var addedImage = addedProd.image;

                cartHTML = cartHTMLtemplate;
                cartHTML = cartHTML.replace('[[title]]', addedProd.title);
                cartHTML = cartHTML.replace('[[quantity]]', addedQty);
                cartHTML = cartHTML.replace('[[image_url]]', addedImage);
                cartHTML = cartHTML.replace('[[price]]', Shopify.formatMoney(addedProd.price, "{{amount_no_decimals}}kr "));
                cartHTML = cartHTML.replace('[[line_price]]', Shopify.formatMoney(addedProd.price * addedQty, "{{amount_no_decimals}} kr"));
                cartHTML = cartHTML.replace('[[subtotal]]', Shopify.formatMoney(cartJson.total_price, "{{amount_no_decimals}} kr"));

                var cartDiv = $(cartHTML);
                cartDiv.find('#shop').bind('click', function(){
                    cartDiv.animate({bottom: - cartDiv.outerHeight()}, 500, function(){ $(this).remove(); });
                    return false;
                });
                cartDiv.prependTo('body').css('bottom', - cartDiv.outerHeight()).animate({bottom: 0}, 500);

                Currency.convertAll(shopCurrency, $('[name=currencies]').val());

                $('#header-cart').find('.cart-count').html(cartJson.item_count);
            }, 'html');
        }

        $.post(addURL, form.serialize(), function(itemData) {


            if (typeof(upsell_main) === "function") {
                upsell_main();
            }
            if (typeof(upsell_offer) === "function") {
                upsell_offer();
                jQuery('#giveacceptbtn,#giveclosebtn,.close_image,#facebox_overlay').on('click', function(){
                    cb(itemData);
                });
            } else {
                cb(itemData);
            }

        }, 'text').error(function(data) {
            form = $('form[action="/cart/add"]:not(.noAJAX)').first();
            add = form.find('input[type="submit"]').removeAttr('disabled')[0];
            add_text = $(add).data('prev-content');
            $(add).val(add_text);
            no_stock = false;

            if (data.status === 422) {
                no_stock = true;
                add_text = "Not enough stock of this variant to add to cart."
                alert_box = $("<div class='alert alert-danger error-message'></div>")
                alert_box.html(add_text);
                form.append(alert_box);
                alert_box.show(250);
                setTimeout(function() {
                    alert_box.hide(250, function(){alert_box.remove()});
                }, 3500);
            }

            if(!no_stock) {
                form.addClass('noAJAX');
                form.submit();
            }
        });
        return false;
    });

    $('body').scroll(function() {
        $('#cart-summary-popup').find('#shop').triggerHandler('click');
    });


    var width = $(window).width();

    $(".navbar-pull").click(function() {
        var that = $(this);
        if($(window).width() < 768) {
            $(".navbar-pull-in").toggleClass("open");
            that.toggleClass("collapsed");
            $(document.body).toggleClass("menu-open");
            that.children(".icon-bar").each(function(index) {
                switch (index) {
                    case 0:
                        $(this).toggleClass("left");
                        break;
                    case 1:
                        $(this).toggleClass("hide");
                        break;
                    case 2:
                        $(this).toggleClass("right");
                        break;
                }
            });
        }
    });

    $(".has-child").click(function() {
        var that = $(this);
        var navbarItems = $(".navbar-items");
        var navCon = $(".navcontainer");
        var chevron = that.find(".arrow");

        if($(window).width() < 768) { //that.closest(".navbar-pull-in").hasClass("open")) {
            that.toggleClass("mobile-expanded");
            that.children(".sub-menu").slideToggle(200);
            if(that.hasClass("mobile-expanded")) {
                chevron.addClass("rotate");
            }
            else {
                chevron.removeClass("rotate");
            }
        }
        else {

            if(that.hasClass('expanded')) {
                //Collapsing. Reset state
                that.removeClass('expanded');
                chevron.removeClass("rotate");
                navCon.children(".sub-menu").each(function() {
                    $(this).slideUp(200, function() {
                        $(this).remove();
                    });
                });
            } else {
                var open = false;
                navCon.children(".sub-menu").each(function() {
                    $(this).slideUp(0, function() {
                        $(this).remove();
                        open = true;
                    });
                });
                navbarItems.find(".expanded").each(function() {
                    if($(this) != that) {
                        $(this).removeClass("expanded");
                        $(this).find(".arrow").removeClass("rotate");
                    }
                });
                var menu = that.children(".sub-menu").clone();
                navCon.append(menu);
                var time = open ? 0 : 200;
                menu.slideDown(time);
                that.addClass('expanded');
                chevron.addClass("rotate");
            }
        }
    });


    $(".wrap-3").closest(".sub-menu-left").addClass("long").siblings(".sub-menu-right").addClass("short").find(".menu-image").find("img").addClass("short");
    //$(".wrap-3").closest(".sub-menu-left").addClass("long").siblings(".sub-menu-right").addClass("short");

    //Already visible? Set state
    $('a[data-toggle-target]').click(function(){
        that = $(this);
        var target = $(that.data('toggle-target'));
        target.slideToggle(200)
        target.css("display") === 'block'  ? that.find(".arrow").addClass("rotate") : that.find(".arrow").removeClass("rotate");

    });

    $(window).resize(function() {

        if($(window).width() >= 768){
            $(document.body).removeClass("menu-open");
            $(".navbar-pull-in").removeClass("open")
                .find(".has-child").each(function() {
                $(this).removeClass("mobile-expanded")
                    .children(".sub-menu").hide();
                $(this).find(".arrow").removeClass("rotate");

            });
            $(".navbar-pull").children(".icon-bar").removeClass("left right hide");

        }
        else {
            $(".navcontainer").children(".sub-menu").remove();
            $(".navcontainer").find(".arrow").removeClass("rotate");

        }
    });

    $.fn.fadeImageToNewSrc = function(newSrc, cb) {
        var img = $(this);
        var src = img.attr("src");
        if(src != newSrc) {
            img.animate({'opacity':0}, 200, function() {
                img.attr('src', newSrc);
                img.load(function () {
                    img.animate({'opacity': 1}, 200);
                });
            });
        }
    };

    $(".thumbnail-image").click(function(e) {
        e.preventDefault();
        var that = $(this);
        var mainImage = $(".product-images-main").children('img');
        var src = mainImage.attr("src");
        var newSrc = that.data("image-url");
        if(src != newSrc) {
            mainImage.fadeImageToNewSrc(newSrc);
        }

    });


    $(".date").each(function(){
        $(this).html(function(){
            return new Date().getFullYear();
        })
    })

})(jQuery);
